module.exports = __webpack_public_path__ + "static/img/Jack_Macrae_desktop.9fbffc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Macrae_desktop.jpg
// module id = LvZ3
// module chunks = 0